export function loadNewFeedbackActInfo(actId) {
  return {
    type: 'LOAD_NEW_FEEDBACK_ACT_INFO',
    actId,
  };
}

export function loadNewFeedbackActInfoCompletion(error, data) {
  return {
    type: 'LOAD_NEW_FEEDBACK_ACT_INFO_COMPLETION',
    error,
    data,
  };
}

export function checkNewFeedbackLimit(actId) {
  return {
    type: 'CHECK_NEW_FEEDBACK_LIMIT',
    actId,
  };
}

export function checkNewFeedbackLimitCompletion(error, data) {
  return {
    type: 'CHECK_NEW_FEEDBACK_LIMIT_COMPLETION',
    error,
    data,
  };
}

export function syncNewFeedbackEditInput(input, reset) {
  return {
    type: 'SYNC_NEW_FEEDBACK_EDIT_INPUT',
    input,
    reset,
  };
}

export function editNewFeedback(id, actId) {
  return {
    type: 'EDIT_NEW_FEEDBACK',
    id,
    actId,
  };
}

export function editNewFeedbackCompletion(id, error, data) {
  return {
    type: 'EDIT_NEW_FEEDBACK_COMPLETION',
    id,
    error,
    data,
  };
}

export function loadNewFeedbackList(actId, show, query) {
  return {
    type: 'LOAD_NEW_FEEDBACK_LIST',
    actId,
    show,
    query,
    willReload: !!query,
  };
}

export function loadNewFeedbackListCompletion(error, list) {
  return {
    type: 'LOAD_NEW_FEEDBACK_LIST_COMPLETION',
    error,
    list,
  };
}

export function loadOwnNewFeedbackInfo(actId) {
  return {
    type: 'LOAD_OWN_NEW_FEEDBACK_INFO',
    actId,
  };
}

export function loadOwnNewFeedbackInfoCompletion(error, data) {
  return {
    type: 'LOAD_OWN_NEW_FEEDBACK_INFO_COMPLETION',
    error,
    data,
  };
}

export function loadNewFeedbackDetail(id) {
  return {
    type: 'LOAD_NEW_FEEDBACK_DETAIL',
    id,
  };
}

export function loadNewFeedbackDetailCompletion(id, error, data) {
  return {
    type: 'LOAD_NEW_FEEDBACK_DETAIL_COMPLETION',
    id,
    error,
    data,
  };
}
